<template>
  <div class="travel-agency">
    <div class="upload-id-card">
      <h2>企业信息</h2>
      <p class="mb-4 mt-2" v-if="isGroup">可重新修改、提交审核变更企业信息</p>
      <p v-else>可上传您的企业信息、资质文件，可审核企业通过后自动关联该企业</p>
    </div>
    <ul class="steps">
        <li :class="{'steps-active':activeStep>=1}"><p>1</p>基本信息</li>
        <li :class="{'steps-active':activeStep>=2}"><p>2</p>资质文件</li>
        <li :class="{'steps-active':activeStep>=3}"><p>3</p>审核信息</li>
        <li :class="{'steps-active':activeStep>=4}"><p>4</p>{{isGroup?'通过变更信息':'通过关联企业'}}</li>
    </ul>
    <!--基本资料-->
    <MaterialsFormation ref="materialInformation" v-show="activeStep==1" :formData="formData" />
    <!--资质文件-->
    <MaterialsDocument ref="materialsDocument"   v-show="activeStep==2" :formData="formData" />

    <!--提交成功待审核中-->
    <div class="success-box" v-if="activeStep==3">
        <div class="title-box">
        <img src="/images/public/success/isSuccess_1.jpg" alt="">
        <h2>您的资料已提交，正在审核中</h2>
        <p>我们将在1—3个工作日内完成审核,请耐心等待。</p>
        <p>审核结果将通过短信或站内信通知您。</p>
      </div>
    </div>
    <!--操作按钮-->
    <div class="steps-botton">
      <el-button  @click="activeStep=1" style="width: 20%;" v-show="activeStep==2">上一步</el-button>
      <el-button type="primary" @click="nextStep" style="width: 20%;" v-show="activeStep==1">下一步</el-button>
      <el-button type="primary" @click="reVerify" style="width: 20%;" v-show="activeStep==2" v-if="!isGroup">保存资料</el-button>
      <!--企业提交审核-->
      <el-button type="primary" @click="reSubmit" style="width: 20%;" v-show="activeStep==2" v-else>提交审核</el-button>
    </div>
    <div class="steps-botton mt-4" v-if="!isGroup&&storeInfo.storeId>0">
      <el-button type="success" @click="submit" style="width: 41%;" v-show="activeStep==2">提交审核</el-button>
    </div>
  </div>
</template>

<script>
  import MaterialsFormation from './Components/MaterialsFormation.vue'
  import MaterialsDocument from './Components/MaterialsDocument.vue'
  import { mapGetters,mapActions,mapState } from 'vuex'
  import { UploadImages } from '@/assets/utils/uploadFiles'
  export default {
    name: 'TravelAgency',
    components: {MaterialsFormation,MaterialsDocument},
    props: {},
    data() {
      return {
        activeStep: -1,         //当前步骤 
        formData: {
          title: "",           //采购商名称
          travel_tel: "",      //办公电话
          district: "",        //区县编码
          address: "",         //详细地址
          province_name: '',
          city_name: '',
          district_name: '',
          province: "",        //省份编码
          city: "",            //城市编码
          district: "",        //区县编码
          certpic: '',
          licence: '',
          certfire: '',               //消防验收合格证
          certheal: '',               //卫生许可证
          certspec: '',                 //特种行业许可证
          unity_code: "",       //统一社会信用代码
          longitude: "",       //经度
          latitude: "",        //纬度
        },
      };
    },
    computed: {
      ...mapState(["newMessageInform"]),
      ...mapGetters(['storeInfo','isGroup','userInfo']),
    },
    watch: {
      //收到消息推送刷新信息
      newMessageInform (newVal) {
        if(newVal.type==41){
            this.initStoreInfo()
        }
      },
    },
    created() {},
    mounted() {
      this.initStoreInfo()
    },
    methods: {
      ...mapActions(['POST_HotelInfo','POST_UnionRecordSaleList','POST_BuyEnterpriseSubmit','POST_BuyEnterpriseSave','setStoreVerify']),
      initStoreInfo () {
        if (this.storeInfo.storeId>0) {
          this.POST_HotelInfo({
            data: {
              store_id: this.storeInfo.storeId,
            },
            successFun: (res) => {
              console.log(res)
              this.formData=this.$_Object.getMergedObj(this.formData,res);
                this.activeStep=res.edit_status==1?3:1;
            }
          })
        }else{
            this.activeStep=1;
        }
      },
      //验证基本信息是否完整
      async nextStep() {
        try {
          const formData = await this.$refs.materialInformation.handleSubmit()
          this.formData={...formData};
          this.activeStep=2;
          // 校验成功逻辑，下一步
        } catch (err) {}
      },
      //验证资质文件是否完整
      async reVerifyStep() {
        try {
          const formData = await this.$refs.materialsDocument.handleSubmit();
          // 校验成功返回数据
          return formData;
          // 校验成功逻辑，下一步
        } catch (err) {
          return false;
        }
      },
      //上传文件
      async uploadFile(formData) {
          // 循环判断formData里的图片字段，有值就上传
        const imgFields = ['certpic', 'licence', 'certfire', 'certheal', 'certspec']
        for (const key of imgFields) {
            const imgVal = formData[key]
            if (imgVal) { // 判断该字段有图片（非空）
                // 上传图片，返回图片链接
                const resList = await UploadImages(imgVal)
                formData[key] = resList[0]
            }
        }
        this.formData={...this.formData,...formData};
      },
      /*保存门店基本信息*/
      async reVerify() {
        let res = await this.reVerifyStep();
          if(!res)return;
          this._confirm('确定保存企业信息么？',async () => {
            await this.uploadFile(res);
            this.POST_BuyEnterpriseSave({
              data: this.formData,
              successFun: async () => {
                //更新门店信息
              }})
          })
      },
      //提交资质认证
      async submit() {
        this._confirm('确认提交企业资质认证么？',async () => {
        this.POST_BuyEnterpriseSubmit({
            data: this.formData,
            successFun: () => {
              //更新门店信息
              this.activeStep=3;
            }})
        })
      },
      //企业重新提交审核
      async reSubmit() {
        let res = await this.reVerifyStep();
        if(!res)return;
        this._confirm('确认重新提交企业资质认证么？',async () => {
          await this.uploadFile(res);
          this.setStoreVerify({
            data: this.formData,
            verify: '3', 
            successFun: () => {
              //更新门店信息
              this.activeStep=3;
            }
          });
        })
      }
    }
};
</script>

<style lang="scss" scoped>
    //步骤条
    .steps{
        display: flex;
        justify-content: space-between;
        margin: 20px auto;
        border-bottom: 1px dashed #d1dffa;
        padding-bottom: 20px;
        li{
            display: flex;
            position: relative;
            &::after{
                content: '';
                position: absolute;
                top: 10px;
                left: 130px;
                width: 200%;
                height: 1px;
                background: #d1dffa;
            }
        }
        li:nth-child(3){
            &::after{
                width: 230%;
            }
        }
        li:nth-child(4){
            &::after{
                display: none;
            }
        }
        p{
            width: 20px;
            height: 20px;
            line-height: 20px;
            border-radius: 50%;
            text-align: center;
            border: 1px solid #d1dffa;
            font-size: 12px;
            margin-right: 10px;
        }
    }
    .steps-active{
        p{
            background: var(--smtc-color-primary);
            color: #fff;
        }
    }
    .travel-agency{
        text-align: left;
        margin:20px auto;
        width: 1200px;
    }
    .upload-id-card{
      position: relative;
      p{
        font-size: 14px;
        color: #999;
      }
    }
    .steps-botton{
      display: flex;
      justify-content: center;
    }
    
    .title-box img{
      width: 300px;
   
    }
    .title-box p {
      color: #888;
      margin: 6px 0 24px;
      margin-top:20px;
      text-align: center;
    }
    .success-box{
      display: flex;
      justify-content: center;

    }
    .modify{
      display: flex;
      justify-content:space-between;
    }
</style>
